import React, { useEffect, useState } from "react";
import { Plus, Minus } from "lucide-react";
import Reveal from "@/components/Reveal";
import { fetchFaqs } from "@/lib/api";

export const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    fetchFaqs().then(setFaqs).catch(() => setFaqs([]));
  }, []);

  return (
    <section className="bg-white border-t border-[#EAEAEA]" data-testid="faq-section">
      <div className="max-w-[1024px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <Reveal>
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
              Frequently asked
            </div>
            <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
              Real questions from{" "}
              <span className="hl-yellow">First-Time Founders</span>.
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 divide-y divide-[#EAEAEA] border border-[#EAEAEA] rounded-2xl overflow-hidden bg-white">
          {faqs.map((f) => {
            const isOpen = open === f.id;
            return (
              <div key={f.id} data-testid={`faq-item-${f.id}`}>
                <button
                  onClick={() => setOpen(isOpen ? null : f.id)}
                  className="w-full flex items-center justify-between gap-6 px-6 py-5 text-left hover:bg-[#F8F9FA] transition-colors"
                  data-testid={`faq-toggle-${f.id}`}
                >
                  <span className="font-display font-bold text-[16px] md:text-[18px] text-[#0F1115]">
                    {f.question}
                  </span>
                  <span
                    className={`w-9 h-9 shrink-0 rounded-full flex items-center justify-center transition-colors ${isOpen ? "bg-[#0F1115] text-[#FDD805]" : "bg-[#FFF9E6] text-[#0F1115]"}`}
                  >
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 text-[15px] leading-relaxed text-[#1C1F26]">
                    {f.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
